import React from 'react';

function ResetPassword() {
  return <h1 className="text-6xl">{'<ResetPassword />'}</h1>;
}

export default ResetPassword;
